<template>
    <div class="row mt-3">
        <div class="col-xl-3 col-lg-4">
            <vueCustomScrollbar class="b-chapter-scroll">
                <transition-group type="transition">
                    <ChapterCollapse :item="item" v-for="(item, index) of listChapter" :key="index" @handleToggleCollapse="handleToggleCollapse">
                        <template v-slot:post>
                            <b-collapse class="mt-1" :visible="item.isCollapse">
                                <PostCollapse :item="post" v-for="(post, indexPost) of item.listPostClassSchool" :key="indexPost" :indexChapter="index" @handleToggleCollapsePost="handleToggleCollapsePost">
                                    <template v-slot:lecture>
                                        <b-collapse class="mt-1" :visible="post.isCollapse">
                                            <LectureCollapse :item="document" v-for="(document, indexDocument) of post.listDocumentClassSchool" :key="indexDocument" />
                                        </b-collapse>
                                    </template>
                                </PostCollapse>
                            </b-collapse>
                        </template>
                    </ChapterCollapse>
                </transition-group>
                <div class="mt-2 p-2">
                    <div @click="handleToggleCollapseFile" class="name-files display-flex-center">
                        <strong>Tài liệu đính kèm</strong>
                    </div>
                    <b-collapse class="mt-1" :visible="isCollapseFiles">
                        <div class="display-flex-center p-1" v-for="n in 3">
                            <a href="#"> 
                                Tài liệu {{ n }}
                            </a>
                        </div>
                    </b-collapse>
                </div>
            </vueCustomScrollbar>
        </div>
        <div class="col-xl-9 col-lg-8">
            <vueCustomScrollbar class="content">
                
            </vueCustomScrollbar>
        </div>
    </div>
</template>
<script>
import moment from "moment"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ChapterCollapse from './ChapterCollapse'
import PostCollapse from './PostCollapse'
import LectureCollapse from './LectureCollapse'

export default {
    components:{
        vueCustomScrollbar,
        ChapterCollapse,
        PostCollapse,
        LectureCollapse
    },
    data() {
        return {
            listChapter: [
                {
                    id: 1,
                    name: 'Chương 1',
                    isCollapse: false,
                    listPostClassSchool: [
                        {
                            id: 11,
                            name: 'Bài 1',
                            isCollapse: false,
                            listDocumentClassSchool: [
                                {
                                    id: 1,
                                    name: 'Bài giảng 1',
                                },
                                {
                                    id: 2,
                                    name: 'Bài giảng 2',
                                },
                                {
                                    id: 3,
                                    name: 'Bài giảng 3',
                                },
                            ]
                        },
                        {
                            id: 12,
                            name: 'Bài 2',
                            isCollapse: false,
                            listDocumentClassSchool: [
                                {
                                    id: 4,
                                    name: 'Bài giảng 1',
                                },
                                {
                                    id: 5,
                                    name: 'Bài giảng 2',
                                },
                                {
                                    id: 6,
                                    name: 'Bài giảng 3',
                                },
                            ]
                        },
                    ]
                },
                {
                    id: 2,
                    name: 'Chương 2',
                    isCollapse: false,
                    listPostClassSchool: [
                        {
                            id: 13,
                            name: 'Bài 1',
                            isCollapse: false,
                            listDocumentClassSchool: [
                                {
                                    id: 1,
                                    name: 'Bài giảng 1',
                                },
                                {
                                    id: 2,
                                    name: 'Bài giảng 2',
                                },
                                {
                                    id: 3,
                                    name: 'Bài giảng 3',
                                },
                            ]
                        },
                        {
                            id: 14,
                            name: 'Bài 2',
                            isCollapse: false,
                            listDocumentClassSchool: [
                                {
                                    id: 4,
                                    name: 'Bài giảng 1',
                                },
                                {
                                    id: 5,
                                    name: 'Bài giảng 2',
                                },
                                {
                                    id: 6,
                                    name: 'Bài giảng 3',
                                },
                            ]
                        },
                    ]
                },
            ],
            isCollapseFiles: false
        }
    },
    mounted(){
       
    },
    methods:{
        moment,
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(0);
        },
        handleToggleCollapse(item, index){
            for (let i = 0; i < this.listChapter.length; i++) {
                if (this.listChapter[i].id != item.id) {
                    this.listChapter[i].isCollapse = false
                }
            }
            item.isCollapse = !item.isCollapse
        },
        handleToggleCollapsePost(item, index){
            if (this.listChapter.length > 0) {
                let listPostClassSchool = this.listChapter[index].listPostClassSchool
                for (let i = 0; i < listPostClassSchool.length; i++) {
                    if (listPostClassSchool[i].id != item.id) {
                        listPostClassSchool[i].isCollapse = false
                    }
                }
            }
            item.isCollapse = !item.isCollapse
        },
        handleToggleCollapseFile() {
            this.isCollapseFiles = !this.isCollapseFiles
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    padding: 0.5rem 2rem;
    border: 1px solid #dee2e6;
    border-radius: 0.6rem;
    min-height: 30rem;
}
.icon-edit {
    width: 15px;
    cursor: pointer;
}
.name-files {
    cursor: pointer;
    border-bottom: 1px solid #dee2e6;
}
</style>